<script>
    import { onMount } from 'svelte';
    import { omit } from 'lodash-es';

    let { lazyComponent, ...props } = $props();

    let restProps = $derived(omit(props, 'lazyComponent'));

    let loadedComponent = $state();
    let error = $state();

    onMount(() => {
        lazyComponent()
            .then(component => {
                loadedComponent = component;
            })
            .catch(err => {
                error = err;
            });
    });

    const SvelteComponent = $derived(loadedComponent);
</script>

<SvelteComponent {...restProps} />
{#if error}
    <p>Failed to load the component.</p>
{/if}
